module.exports = __webpack_public_path__ + "media/images/undraw/fill_form-78eb80b0a56b3eace112d9b496dd7d25.png";